import "./App.css";
import "./index.css";

import AT from "./Screens/AT";
import CE from "./Screens/CE";
import MK from "./Screens/MK";
import WS from "./Screens/WS";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import LabScreen from "./Screens/LabScreen";
import Work from "./Screens/Work";
import Partner from "./Screens/Partner";
import About from "./Screens/About";
import HomePage from "./Screens/HomePage";

import TruckLandingPage from "./Screens/Landing_Pages_js/Truck";
import HRLandingPage from "./Screens/Landing_Pages_js/HR";
import VoicebotLandingPage from "./Screens/Landing_Pages_js/Voicebot";
import ProposalLandingPage from "./Screens/Landing_Pages_js/Proposal";


import TruckDispatchNew from "./Screens/new_ads/TruckDispatch_new";
import AIVoiceNew from "./Screens/new_ads/aivoice_new";
import ConversionWebsites from "./Screens/new_ads/conversionwebsites";
import CustomInternalSoftwareNew from "./Screens/new_ads/customsoftware";
import AutomationPageNew from "./Screens/new_ads/automation_page_new";
import HROperationsNew from "./Screens/new_ads/hroperations";
import GrowthAutomationNew from "./Screens/new_ads/growthautomation";

import ScrollToTop from "./Components/ScrollToTop";
import ThankYou from "./Screens/ThankYou";
function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/thank-you" element={<ThankYou />} />
          <Route exact path="/AI_Automation" element={<AT />} />
          <Route exact path="/CustomSoftware" element={<CE />} />
          <Route exact path="/MarketingSystem" element={<MK />} />
          <Route exact path="/Web&Conversion" element={<WS />} />
          <Route exact path="/Labs" element={<LabScreen />} />
          <Route exact path="/How_we_work" element={<Work />} />
          <Route exact path="/PartnerShips" element={<Partner />} />
          <Route exact path="/AboutUs" element={<About />} />


          {/* Landing pages */}
          <Route exact path="/lp/truck-dispatch" element={<TruckLandingPage />} />
          <Route exact path="/lp/ai-voice" element={<VoicebotLandingPage />} />
          <Route exact path="/lp/proposal-system" element={<ProposalLandingPage />} />
          <Route exact path="/lp/hros" element={<HRLandingPage />} />



          {/* ad pages routes */}
          <Route exact path="/ad/marketing-growth-new" element={<GrowthAutomationNew />} />
          <Route exact path="/ad/truck-dispatch-new" element={<TruckDispatchNew />} />
          <Route exact path="/ad/ai-voice-new" element={<AIVoiceNew />} />
          <Route exact path="/ad/conversion-websites-new" element={<ConversionWebsites />} />
          <Route exact path="/ad/custom-software-new" element={<CustomInternalSoftwareNew />} />
          <Route exact path="/ad/automation-page-new" element={<AutomationPageNew />} />
          <Route exact path="/ad/hroperations-new" element={<HROperationsNew />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;


